import { isEmpty } from "lodash";
import type { useInvestorInfo } from "../hooks";
import { ClientHoldingPattern, ClientStatus } from "../types";

export const TAX_STATUS_FILTER_LABEL_MAP: Record<string, string> = {
  resident_individual: "Individual",
  nri: "NRI",
  on_behalf_of_minor: "Minor",
  huf: "HUF",
  company: "Company",
  aop: "Company",
  partnership_firm: "Company",
  body_corporate: "Company",
  trust: "Company",
  society: "Company",
  others: "Others",
  dfi: "Company",
  sole_proprietorship: "Company",
  nri_repatriable_nre: "NRI",
  ocb: "Company",
  fii: "Company",
  nri_repatriable_nro: "NRI",
  overseas_corp_body_others: "Company",
  nri_child: "NRI",
  nri_huf_nro: "NRI",
  nri_minor_nro: "NRI",
  nri_huf_nre: "NRI",
  providend_fund: "Others",
  super_annuation_fund: "Others",
  gratuity_fund: "Others",
  pension_fund: "Others",
  mutual_funds_fof_schemes: "Others",
  nps_trust: "Others",
  global_development_network: "Others",
  fcra: "Others",
  qfi_individual: "Others",
  qfi_minors: "Others",
  qfi_corporate: "Others",
  qfi_pension_funds: "Others",
  qfi_hedge_funds: "Others",
  qfi_mutual_funds: "Others",
  llp: "Company",
  non_profit_organization_npo: "Others",
  public_limited_company: "Company",
  private_limited_company: "Company",
  unlisted_company: "Company",
  mutual_funds: "Others",
  fpi_category_i: "Others",
  fpi_category_ii: "Others",
  fpi_category_iii: "Others",
  financial_institutions: "Others",
  body_of_individuals: "Others",
  insurance_company: "Others",
  oci_repatriation: "NRI",
  oci_non_repatriation: "NRI",
  person_of_indian_origin: "NRI",
  government_body: "Others",
  defence_establishment: "Others",
  non_government_organisation: "Others",
  bank_cooperative_bank: "Others",
  artificial_juridical_person: "Others",
  seafarer_nre: "NRI",
  seafarer_nro: "NRI",
  local_authority: "Others",
};

export const TAX_STATUSES = Object.keys(TAX_STATUS_FILTER_LABEL_MAP);

export const NRI_TAX_STATUSES = new Set(
  Object.entries(TAX_STATUS_FILTER_LABEL_MAP)
    .filter(([, value]) => value.toLowerCase().includes("nri"))
    .map(([key]) => key)
);

export const TRANSACTION_CLIENT_STATES: ClientStatus[] = [
  "ACTIVE",
  "UPDATE_PENDING",
];

export const INACTIVE_CLIENT_STATUSES: ClientStatus[] = [
  "LEAD",
  "VERIFICATION_PENDING",
  "SETUP_PENDING",
];

export const ACTIVE_STATUSES: ClientStatus[] = [
  "ACTIVE",
  "UPDATE_PENDING",
  "UPDATE_UNDER_REVIEW",
  "AUTHENTICATION_PENDING",
];

export const FAMILY_CLIENT_STATES: ClientStatus[] = [
  ...ACTIVE_STATUSES,
  "SETUP_PENDING",
];

export const JOINT_CLIENT_HOLDING_PATTERNS: ClientHoldingPattern[] = [
  "anyone_or_survivor",
  "joint",
];

export const ONBOARDING_STEPS: {
  label: string;
  id: string;
  completed: (data: ReturnType<typeof useInvestorInfo>["data"]) => boolean;
}[] = [
  {
    id: "personal-details",
    label: "Personal details",
    completed: (data) => !!data.profile?.gender,
  },
  {
    id: "address",
    label: "Address",
    completed: (data) => !!data.address,
  },
  {
    id: "bank-details",
    label: "Bank details",
    completed: (data) => !isEmpty(data.bank),
  },
  {
    id: "financial-profile",
    label: "Financial profile",
    completed: (data) => !!data.profile?.pep_details,
  },
  {
    id: "nominee",
    label: "Nominee",
    completed: (data) =>
      !!data.nominee?.[0] || data.account?.nomination_opt === "N",
  },
  {
    id: "declaration",
    label: "Declaration",
    completed: (data) =>
      !!data.contact &&
      (!!data.contact.autofilled ||
        (!!data.contact.number &&
          !!data.contact.phone_belongs_to &&
          !!data.contact.email &&
          !!data.contact.email_belongs_to)),
  },
  {
    id: "notify-client",
    label: "Notify client",
    completed: () => false,
  },
];
